import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Sparkles, Bell } from "lucide-react";

// Reusable placeholder for features not yet built. Keep the app scalable:
// point new routes here until the real tool/module ships.
export default function ComingSoon({
  icon: Icon = Sparkles,
  eyebrow = "Coming soon",
  title,
  description,
  note,
  backTo = "/v2",
  backLabel = "Back to dashboard",
  testid = "coming-soon",
}) {
  return (
    <div className="max-w-2xl mx-auto px-6 py-20" data-testid={testid}>
      <motion.div
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="rounded-3xl bg-white border border-slate-200 p-10 text-center"
      >
        <div className="w-16 h-16 rounded-2xl bg-brand/10 flex items-center justify-center mx-auto mb-6">
          <Icon className="w-8 h-8 text-brand" />
        </div>
        <div className="inline-flex items-center gap-1.5 text-xs tracking-[0.2em] uppercase font-bold text-brand mb-3">
          <Bell className="w-3.5 h-3.5" /> {eyebrow}
        </div>
        <h1 className="font-heading text-3xl sm:text-4xl font-black tracking-tight text-slate-900">{title}</h1>
        {description && <p className="mt-4 text-slate-600 leading-relaxed max-w-md mx-auto">{description}</p>}
        {note && (
          <div className="mt-6 rounded-2xl bg-slate-50 border border-slate-100 p-4 text-sm text-slate-500 leading-relaxed">
            {note}
          </div>
        )}
        <div className="mt-8">
          <Link to={backTo} data-testid="coming-soon-back">
            <Button variant="outline" className="rounded-full border-slate-300 h-12 px-6 font-bold">
              <ArrowLeft className="w-4 h-4 mr-2" /> {backLabel}
            </Button>
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
